<script>
    import { NavItem, NavLink } from 'sveltestrap'
    import Icon from 'svelte-awesome'
    import { checkSquare, square } from 'svelte-awesome/icons'
    export let asr
    export let schoolId
    export let path
    export let title
    export let showIcon
    export let status

    let active
    let href
    $: active = asr.stateIsActive(path, { schoolId })
    $: href = asr.makePath(path, { schoolId })
</script>

<style>
    :global(svg.task-status) {
        vertical-align: text-bottom;
        margin-right: 10px;
    }
</style>

<NavItem>
    <NavLink {href} {active}>
        {#if showIcon && status === 'COMPLETED'}
            <Icon class="task-status" data={checkSquare} />
        {:else if showIcon}
            <Icon class="task-status" data={square} />
        {/if}
        {title}
    </NavLink>
</NavItem>
